module.exports = __webpack_public_path__ + "img/Ookeditse-Malesu.f43fc1b8.jpg";